(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('WorkingDayDialogController', WorkingDayDialogController);

    WorkingDayDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'WorkingDay', 'CustomerSector'];

    function WorkingDayDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, WorkingDay, CustomerSector) {
        var vm = this;
        vm.workingDay = entity;
        vm.customersectors = CustomerSector.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:workingDayUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.workingDay.id !== null) {
                WorkingDay.update(vm.workingDay, onSaveSuccess, onSaveError);
            } else {
                WorkingDay.save(vm.workingDay, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
